
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '~src/spacesPlatform/models/resourceParts';
import { IView } from '~src/views/ServerApi/types/IView';

import { IAccelerationRecommendation } from '../types/IAccelerationRecommendation';

export interface IGetAccelerationRecommendationsResult extends IGetItemsResult {
  recommendations: IAccelerationRecommendation[];
  workbooks: INamedItem[];
  views: IView[];
  projects: INamedItem[];
}

export class GetAccelerationRecommendationsRequest extends Request<IGetItemsParams, IGetAccelerationRecommendationsResult> {
  constructor(params: IGetItemsParams) {
    super('getAccelerationRecommendations', params);
  }
}
